export default {
  defaultTotal: true,
};
